import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Hlavutelo</span> from{" "}
            <span className="purple"> South Africa.</span>
            <br />
            I am currently employed as a Data Engineer Intern at Capaciti.
            <br />
            I have completed a Diploma in Information Technology in Software
            Development from IIE Rosebank College.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning new Skillsets
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer">Hlavutelo</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
